import styled from 'styled-components'

export const Container = styled.div`
  > button {
    width: 100%;
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .customSpinner {
    width: 30px;
    height: 30px;
    border: 4px solid;
    border-top-color: transparent;
  }

  .errorMessageWrapper {
    max-width: 100%;

    > p {
      color: #fff;
    }
  }
`

export const TextWrapper = styled.div`
  margin: 10px 0 20px;
  > p {
    > span {
      font-weight: 600;
      color: #FF3D3D;
    }
  }
`

export const DateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const SpinnerWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 20rem;
`